/**
 * Vuely Global Components
 */
import VuePerfectScrollbar from 'vue-perfect-scrollbar'

const globalComponents = {
  install (Vue) {
    Vue.component('vuePerfectScrollbar', VuePerfectScrollbar)
  }
}

export default globalComponents



// WEBPACK FOOTER //
// ./src/global_components.js